import React from "react";

const Navbar: React.FC = () => {
  return (
    <nav className="navbar">
      <h1 className="navbar-title">Gestión de Inventario</h1>
    </nav>
  );
};

export default Navbar;